import {applyMiddleware, createStore} from 'redux';
import rootReducer from "./reducers/rootReducer";
import apiMiddleware from "./middleware/apiMiddleware";
export default function configureStore() {
    const enhancer = applyMiddleware(apiMiddleware);
    const store = createStore(rootReducer, {}, enhancer);
    return store;
}
